// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3792) return "static/chunks/3792-ed23d26f9f43a7d4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "b33b9dc57439a583" + ".js";
};